import { FaFacebookF, FaInstagram, FaLinkedinIn, FaPinterestP, FaYoutube, FaPhoneAlt, FaEnvelope, FaClock, FaMapMarkerAlt } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import { Link } from 'react-router-dom';
import '../css/main.css';

const socialLinks = [
  {
    label: 'Instagram',
    icon: FaInstagram,
    href: 'https://www.instagram.com/edges.design.group/',
    hoverBg: 'hover:bg-pink-600',
  },
  {
    label: 'Facebook',
    icon: FaFacebookF,
    href: 'https://www.facebook.com/profile.php?id=61559936103250',
    hoverBg: 'hover:bg-blue-600',
  },
  {
    label: 'LinkedIn',
    icon: FaLinkedinIn,
    href: 'https://www.linkedin.com/in/edges-design-group-06857a364/?skipRedirect=true',
    hoverBg: 'hover:bg-sky-600',
  },
  {
    label: 'Pinterest',
    icon: FaPinterestP,
    href: 'https://www.pinterest.com/edgesgroup6/',
    hoverBg: 'hover:bg-red-600',
  },
  {
    label: 'YouTube',
    icon: FaYoutube,
    href: 'https://www.youtube.com/@Edges_Design_Group',
    hoverBg: 'hover:bg-red-500',
  },
  {
    label: 'X / Twitter',
    icon: FaXTwitter,
    href: 'https://x.com/Edges_Design',
    hoverBg: 'hover:bg-gray-700',
  },
];

function Footer() {
  return (
    <footer className="bg-teal-900 text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12 pt-16 pb-10 grid grid-cols-1 md:grid-cols-4 gap-10">

        {/* Brand + Social */}
        <div className="md:col-span-1">
          <h1 className="text-xl font-black tracking-wide mb-3 text-white">EDGES DESIGN GROUP</h1>
          <p className="text-gray-300 leading-relaxed text-sm mb-6">
            Turning ideas into enduring realities through innovative architectural and construction solutions.
          </p>

          <p className="text-xs font-semibold uppercase tracking-widest text-teal-400 mb-3">Follow Us</p>
          <div className="flex gap-3">
            {socialLinks.map(({ label, icon: Icon, href, hoverBg }) => (
              <a
                key={label}
                href={href}
                aria-label={label}
                target="_blank"
                rel="noopener noreferrer"
                className={`w-9 h-9 flex items-center justify-center rounded-full border border-white/20 bg-white/10 text-white transition-all duration-200 ${hoverBg} hover:border-transparent hover:scale-110`}
              >
                <Icon size={15} />
              </a>
            ))}
          </div>
        </div>

        {/* Quick Links */}
        <div>
          <h3 className="text-sm font-semibold uppercase tracking-widest text-teal-400 mb-4">Quick Links</h3>
          <ul className="space-y-2 text-sm">
            {[
              { label: 'Home', to: '/' },
              { label: 'About Us', to: '/about' },
              { label: 'Services', to: '/services' },
              { label: 'Projects', to: '/projects' },
              { label: 'Gallery', to: '/gallery' },
              { label: 'Contact', to: '/contacts' },
            ].map(({ label, to }) => (
              <li key={to}>
                <Link
                  to={to}
                  className="text-gray-300 hover:text-white hover:pl-1 transition-all duration-150"
                >
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact Info */}
        <div>
          <h3 className="text-sm font-semibold uppercase tracking-widest text-teal-400 mb-4">Contact</h3>
          <ul className="space-y-4 text-sm text-gray-300">
            <li className="flex items-start gap-3">
              <FaPhoneAlt className="text-teal-400 mt-0.5 shrink-0" />
              <span>+250 788 570 601</span>
            </li>
            <li className="flex items-start gap-3">
              <FaEnvelope className="text-teal-400 mt-0.5 shrink-0" />
              <span>contact@edgesdesigngroup.com</span>
            </li>
            <li className="flex items-start gap-3">
              <FaMapMarkerAlt className="text-teal-400 mt-0.5 shrink-0" />
              <span>KK 04 Ave - Gikondo, Kigali</span>
            </li>
            <li className="flex items-start gap-3">
              <FaMapMarkerAlt className="text-teal-400 mt-0.5 shrink-0" />
              <span>Providence House, Rm 216 — Nyamata</span>
            </li>
            <li className="flex items-start gap-3">
              <FaClock className="text-teal-400 mt-0.5 shrink-0" />
              <span>Mon – Fri: 8:00 – 17:00</span>
            </li>
          </ul>
        </div>

        {/* Newsletter */}
        <div>
          <h3 className="text-sm font-semibold uppercase tracking-widest text-teal-400 mb-4">Stay Updated</h3>
          <p className="text-gray-300 text-sm mb-4">Get the latest insights and project updates delivered to your inbox.</p>
          <form className="flex flex-col gap-2" onSubmit={(e) => e.preventDefault()}>
            <input
              type="email"
              placeholder="Your email address"
              className="w-full px-4 py-2 rounded bg-white/10 border border-white/20 text-white placeholder-gray-400 focus:outline-none focus:border-teal-400 text-sm"
            />
            <button
              type="submit"
              className="bg-teal-600 hover:bg-teal-500 active:bg-teal-700 px-4 py-2 text-sm font-semibold rounded text-white transition-colors duration-150"
            >
              Subscribe
            </button>
          </form>
        </div>
      </div>

      {/* Divider + Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-4 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-gray-400">
          <p>&copy; {new Date().getFullYear()} Edges Design Group. All rights reserved.</p>
          <p>Designed by <a href="https://planktonz.space/" target="_blank" rel="noopener noreferrer" className="text-teal-400 hover:text-white transition-colors duration-150">Plankton</a>.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
